import canadaStates from 'assets/data/canada-states.json';
import { AdminRole, ClinicLocation } from 'context/userContext';
import { ROLE } from 'utils/constants';

export const getLocationName = (location: ClinicLocation) => {
  const stateAbbr =
    canadaStates.find((item) => item.name === location.state)?.abbreviation ||
    location.state;
  return `${location.city}, ${stateAbbr}`;
};

export const getAdminViewName = (adminRole: AdminRole | null) => {
  if (adminRole?.role === ROLE.GLOBAL_ADMIN) return 'Global Admin';
  if (adminRole?.role === ROLE.GROUP_ADMIN)
    return `${adminRole.clinicGroup?.name} Admin`;
  return null;
};
